import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
type UmamiOptions = {
  hostUrl?: string;
  domains?: string[];
  tag?: string;
  excludeSearch?: boolean;
  excludeHash?: boolean;
  doNotTrack?: boolean;
  autoTrack?: boolean;
};
type UmamiScriptProps = {
  websiteId: string;
  src: string;
  options?: UmamiOptions;
};
export function UmamiScript(t0) {
  const $ = _c(12);
  const {
    websiteId,
    src,
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options?.domains?.length ? options.domains.join(",") : undefined;
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const domains = t1;
  const t2 = options?.hostUrl;
  const t3 = options?.tag;
  const t4 = options?.doNotTrack === undefined ? undefined : String(options.doNotTrack);
  const t5 = options?.excludeSearch === undefined ? undefined : String(options.excludeSearch);
  const t6 = options?.excludeHash === undefined ? undefined : String(options.excludeHash);
  const t7 = options?.autoTrack === undefined ? undefined : String(options.autoTrack);
  let t8;
  if ($[2] !== domains || $[3] !== src || $[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== t6 || $[9] !== t7 || $[10] !== websiteId) {
    t8 = <Script id="umami-analytics" src={src} async={true} data-website-id={websiteId} data-host-url={t2} data-domains={domains} data-tag={t3} data-do-not-track={t4} data-exclude-search={t5} data-exclude-hash={t6} data-auto-track={t7} />;
    $[2] = domains;
    $[3] = src;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = websiteId;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}